import PeopleSelect from './modules/people-select';
import Gradient from './modules/gradient';
import Mouse from './modules/mouse';
import Carousel from './modules/carousel';
import Wheel from './modules/wheel';
import Clock from './modules/clock';
import Search from './modules/search';
import Subscribe from './modules/subscribe';
import Modal from './modules/modal';
import Filter from './modules/filter';
import Video from './modules/video';
import Tabs from './modules/tabs';
import Toc from './modules/toc';
import Menu from './modules/menu';


const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
let modules = [];
const moduleClasses = {
  PeopleSelect,
  Carousel,
  Wheel,
  Clock,
  Modal,
  Filter,
  Menu,
  Search,
  Video,
  Tabs,
  Toc,
  Subscribe,
};

moduleClasses.Gradient = isDesktop ? Gradient : null;
moduleClasses.Mouse = isDesktop ? Mouse : null;

/**
 * Initialize modules on elements with data-module="ModuleName"
 */
export const initModules = () => {
  const $moduleElements = document.querySelectorAll('[data-module]');
  $moduleElements.forEach(($element) => {
    const id = $element.dataset.module;
    const ModuleClass = moduleClasses[id];
    if (!ModuleClass) return;

    const module = new ModuleClass($element);
    modules.push(module);
  });
};


/**
 * removes module functionality and resets DOM
 */
export const unmountModules = () => {
  modules.forEach((module) => module.unmount());
  modules = [];
};
